<script>
import { findEvents } from '../../vue-app/api/events';

import SingleSelector from "../../vue-app/components/SingleSelector.vue";
import bus from "../utils/eventBus";
import normalizeDropdown from '../utils/dropdown';

export default {
    components: {
        "single-selector": SingleSelector
    },
    props: {
        pageLang: { type: String, default: '' },
        times: { type: Array, default: () => [] },
        industries: { type: Array, default: () => [] },
        types: { type: Array, default: () => [] }
    },
    data() {
        return {
            bus: bus,
            selectedTime: null,
            selectedIndustry: null,
            selectedType: null,
            filteredEvents: [],
            isLoading: false,
            mobileAccordionOpen: false
        };
    },
    computed: {
        showNoResults() {
            return this.filteredEvents.length === 0 && !this.isLoading;
        },
        isAriaExpanded() {
            return this.mobileAccordionOpen ? 'true' : 'false';
        },
        currentRoute() {
            return (this.$router && this.$router.currentRoute) || {};
        },
        currentQuery() {
            if (this.currentRoute.query) {
                return this.currentRoute.query;
            }
            const params = new URLSearchParams(window.location.search);
            const q = {};
            params.forEach((v, k) => { q[k] = v; });
            return q;
        }
    },
    mounted() {
        this.bus.$on('dropdownChange', (val, id) => {
            if (id === 'times') {
                this.selectedTime = normalizeDropdown(val, this.times);
            } else if (id === 'industries') {
                this.selectedIndustry = normalizeDropdown(val, this.industries);
            } else if (id === 'types') {
                this.selectedType = normalizeDropdown(val, this.types);
            }
            this.handleFilterChange();
        });
        window.addEventListener('click', (e) => {
            this.bus.$emit('hideOtherDropdowns', e.target);
        });
        const params = {
            language: this.pageLang
        };
        const query = this.currentQuery || {};

        if (query.time) {
            this.getPreselectedTime(parseInt(query.time));
            if (this.selectedTime) {
                params.timeFilter = this.selectedTime.value;
            }
        } else if (this.times.length > 0) {
            this.selectedTime = this.times[0];
            params.timeFilter = this.selectedTime.value;
        }
        if (query.industry) {
            this.getPreselectedIndustry(parseInt(query.industry));
            if (this.selectedIndustry) {
                params.industryId = this.selectedIndustry.value;
            }
        }
        if (query.type) {
            this.getPreselectedType(parseInt(query.type));
            if (this.selectedType) {
                params.typeId = this.selectedType.value;
            }
        }
        this.searchEvents(params);
    },
    methods: {
        handleFilterChange() {
            const params = {
                language: this.pageLang
            };
            const query = {};

            if (this.selectedTime && this.selectedTime.value !== -1) {
                params.timeFilter = this.selectedTime.value;
                query.time = this.selectedTime.value;
            }
            if (this.selectedIndustry && this.selectedIndustry.value !== -1) {
                params.industryId = this.selectedIndustry.value;
                query.industry = this.selectedIndustry.value;
            }
            if (this.selectedType && this.selectedType.value !== -1) {
                params.typeId = this.selectedType.value;
                query.type = this.selectedType.value;
            }

            this.$router.push({
                path: this.currentRoute.path || window.location.pathname,
                query: query
            }).catch(() => {});

            this.searchEvents(params);
        },
        searchEvents(params) {
            this.isLoading = true;
            findEvents(params)
                .then(response => {
                    this.isLoading = false;
                    this.filteredEvents = response;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        handleClearAllClick() {
            this.clearAll();
        },
        clearAll() {
            this.selectedTime = null;
            this.selectedIndustry = null;
            this.selectedType = null;
            this.handleFilterChange();
        },
        getPreselectedTime(val) {
            this.times.forEach(time => {
                if (time.value === val) {
                    this.selectedTime = time;
                }
            });
        },
        getPreselectedIndustry(val) {
            this.industries.forEach(industry => {
                if (industry.value === val) {
                    this.selectedIndustry = industry;
                }
            });
        },
        getPreselectedType(val) {
            this.types.forEach(type => {
                if (type.value === val) {
                    this.selectedType = type;
                }
            });
        },
        toggleMobileAccordion() {
            this.mobileAccordionOpen = !this.mobileAccordionOpen;
        }
    }
};
</script>